<template>
    <dumb-article title="견적신청서">
        <section v-for="(section, index) in sections" :key="`section-${index}`" class="section">
            <div class="section-title">{{ section.title }}</div>
            <dl v-if="section.data" class="data">
                <div v-for="({ term, detail, type }, index) in section.data" :key="`data-${index}`" :class="type ? 'wanted-style' : ''">
                    <dt>{{ term }}</dt>
                    <dd v-if="type == 'portfolio'">
                        <estimate-inquiry-reference :portfolio="inquiry.portfolio" :isInquiry="true" />
                    </dd>
                    <dd v-else-if="type == 'image'">
                        <img :src="detail" alt="style" />
                    </dd>
                    <dd v-else>{{ detail }}</dd>
                </div>
            </dl>
        </section>
    </dumb-article>
</template>
<script>
import DumbArticle from "./dumb-article.vue";
import EstimateInquiryReference from "../estimate-inquiry-reference.vue";

export default {
    components: { DumbArticle, EstimateInquiryReference },
    props: {
        inquiry: { type: Object, default: null },
    },
    computed: {
        sections() {
            const { inquiry, budget } = this;
            return [
                {
                    title: "신청자",
                    data: [
                        {
                            term: "이름",
                            detail: inquiry.name,
                        },
                        {
                            term: "연락처",
                            detail: inquiry.phone.phoneNumberFormat(),
                        },
                    ],
                },
                {
                    title: "신청개요",
                    data: [
                        {
                            term: "시공지유형",
                            detail: inquiry.category.parents[0].name + "/" + inquiry.category.name,
                        },
                        {
                            term: "시공지면적",
                            detail: (+inquiry.acreage).format() + " 평",
                        },
                        {
                            term: "시공희망일",
                            detail: inquiry.targetDate,
                        },
                        {
                            term: "시공예산",
                            detail: budget,
                        },
                        {
                            term: "시공지주소",
                            detail: `(${inquiry.postcode}) ${inquiry.address1}, ${inquiry.address2}`,
                        },
                    ],
                },
                {
                    title: "신청상세",
                    data: [
                        {
                            term: "요청사항",
                            detail: inquiry.requests,
                        },
                        {
                            term: "원하는스타일",
                            detail: inquiry.portfolio ? inquiry.portfolio : inquiry.image,
                            type: inquiry.portfolio ? "portfolio" : "image",
                        },
                    ],
                },
            ];
        },
        budget() {
            let target = this.inquiry?.budget;
            if (target) {
                if (target.includes("원") || target.includes("미정")) return target;
                else {
                    target = Number(target);
                    if (target > 10000) {
                        return (target / 10000).format() + "억" + (target % 10000 ? `${(target % 10000).format()}만원` : "");
                    } else return (target % 10000).format() + "만원";
                }
            } else return "-";
        },
    },
};
</script>

<style lang="scss" scoped>
.section {
    margin-bottom: 3rem;
}
.section-title {
    font-size: 1.3rem;
}
.data {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    margin: 1rem auto;
}
.data > div {
    display: flex;
    flex-direction: row;
    align-items: baseline;

    flex: 50% 1 0;
    padding: 1rem;

    > dt {
        flex: 7rem 0 0;
    }

    > dd {
        flex: calc(100% - 7rem) 0 0;
        font-size: 1.2rem;
    }

    &.wanted-style {
        flex: 100% 1 0;
        align-items: flex-start;
    }
}
</style>
